import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
// import CreatableSelect from 'react-select/lib/Creatable';

import EyeIcon from 'mdi-react/EyeIcon';
// import renderSelectField from '../../../shared/components/form/Select';
// import global from '../../../global';
import Alert from '../../../shared/components/Alert';
// import SelectService from '../../../services/SelectService';

class EditProfileModal extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    modal: PropTypes.bool,
    // showPassField: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    postValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      }),
    ]),
    handleSubmit: PropTypes.func,
    errorMsg: PropTypes.string,
  };

  static defaultProps = {
    title: 'Manage Account',
    modal: false,
    // showPassField: true,
    postValue: {},
    errorMsg: '',
    handleSubmit: (e) => {
      e.preventDefault();
    },
  };

  constructor(props) {
    super(props);
    this.userdata = JSON.parse(localStorage.getItem('userData'));
    this.state = {
      showPassword: false,
      // locType: 0,
    };
    this.isLoading = false;
    this.toggle = this.toggle.bind(this);
  }

  componentDidMount() {
    this.isLoading = true;
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      title, toggle, modal, errorMsg, handleChange, handleSubmit, postValue,
    } = this.props;
    const { showPassword } = this.state;

    return (
      <div>
        <Modal
          isOpen={modal}
          className="modal-dialog--primary modal-dialog--header"
        >
          <div className="modal__header bg_blue">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
            <h4 className="bold-text  modal__title">{title.toString()}</h4>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal__body p-t-10">
              { errorMsg && (
                <div className="notif_msg">
                  <Alert color="danger" className="alert--colored">
                    <p><span className="fa fa-exclamation">&nbsp;</span> { errorMsg }</p>
                  </Alert>
                </div>
                )
              }
              <div className="form form--horizontal m-t-10">
                <div className="form__form-group">
                  <span className="form__form-group-label">Name <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="hidden" name="user_id" value={this.userdata.user_id} />
                    <input type="text" name="name" value={postValue.name ? postValue.name : this.userdata.name} placeholder="Name" onChange={e => handleChange(e, 'name')} />
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">New Password </span>
                  <div className="form__form-group-field">
                    <input type={showPassword ? 'text' : 'password'} name="newPassword" placeholder="Leave empty if dont want to change" onChange={e => handleChange(e, 'password')} />
                    <button
                      type="button"
                      className={`form__form-group-button${showPassword ? ' active' : ''}`}
                      onClick={e => this.showPassword(e)}
                    ><EyeIcon />
                    </button>
                  </div>
                </div>
                <div className="form__form-group">
                  <span className="form__form-group-label">Current Password <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type={showPassword ? 'text' : 'password'} name="oldPassword" placeholder="Password" onChange={e => handleChange(e, 'password')} />
                    <button
                      type="button"
                      className={`form__form-group-button${showPassword ? ' active' : ''}`}
                      onClick={e => this.showPassword(e)}
                    ><EyeIcon />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button color="primary">Submit</Button>
              <Button onClick={toggle}>Cancel</Button>
            </ButtonToolbar>
          </form>
        </Modal>
      </div>
    );
  }
}

export default reduxForm({
  form: 'EditProfileModal', // a unique identifier for this form
})(withTranslation('common')(EditProfileModal));
